import React from 'react';
import styles from "./shPricing.module.scss";
import { shCurrencyPipe } from "../../helper/pipes/currency-pipe";
import useDiscountState from "../../zustand/discountState";
import useInfoState from "../../zustand/infoState";

const ShAboPriceInstead = (
    {
        mode = 'month',
        isFixMode = false,
        className = '',
        customAboPriceBefore = "",
        type= "basic"
    } : {
        mode?: 'month' | 'year',
        isFixMode?: boolean,
        className?: string,
        customAboPriceBefore?: string,
        type?: string
    }
) => {


    const showMonthlyPrice = useDiscountState( s => s.showMonthlyPrice);

    if(showMonthlyPrice && !isFixMode){
        mode = 'month';
    }

    let  displayAboPriceBefore;

    if(customAboPriceBefore){
        displayAboPriceBefore = customAboPriceBefore;
    } else {
        if (type === "family"){
            displayAboPriceBefore = useInfoState( s => s.aboFamily)?.priceBefore;
            } else if (type === "duo"){
            displayAboPriceBefore = useInfoState( s => s.aboDuo)?.priceBefore;
        } else {
            displayAboPriceBefore = useDiscountState(s => s.displayAboPriceBefore);
        }
    }


    if (!displayAboPriceBefore) {
        return null;
    } else {
        return <span className={className + " strike " + styles.span}> statt&nbsp;
            { mode === 'month' && shCurrencyPipe(displayAboPriceBefore / 12.0)}
            { mode === 'year' && shCurrencyPipe(displayAboPriceBefore)}
        </span>
    }

}

export default ShAboPriceInstead;
